import React from 'react'
import joinClassNames from './joinClassNames.js'

/**
 * Horizontal row for filter chips (active filters or toggle chips).
 *
 * @param {{
 *   label?: string,
 *   emptyText?: string,
 *   className?: string,
 *   children?: React.ReactNode,
 * } & React.HTMLAttributes<HTMLDivElement>} props
 */
export default function FilterChipsRow({
  label,
  emptyText,
  className = '',
  children,
  ...rest
}) {
  const hasChildren = React.Children.count(children) > 0

  if (label) {
    return (
      <div className={joinClassNames('filter-chips-labeled-row', className)} {...rest}>
        <span className="filter-chips-label">{label}</span>
        {hasChildren ? children : (
          emptyText ? <span className="filter-chips-empty">{emptyText}</span> : null
        )}
      </div>
    )
  }

  return (
    <div className={joinClassNames('recipe-filter-chips-row', className)} {...rest}>
      {children}
    </div>
  )
}
